<script>
export default {
}
</script>
<template>
  <icon-base>
    <g>
      <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
    </g>
  </icon-base>
</template>